import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { getPaginationPayload } from '~/utils/pagination';
import { IThunkGetTriageRequests, ITriageStore } from '../types';

const onGetTriageRequests: IThunkGetTriageRequests = thunk(
  // @ts-ignore
  async ({ setTriageRequests, reset }, payload, { getState }) => {
    reset();
    const localState = getState() as ITriageStore;
    const paginationPayload = getPaginationPayload(localState.pagination);

    const { data } = await api.triage.getRequests({
      ...payload,
      ...paginationPayload,
    });

    setTriageRequests(data);
  },
);

export default onGetTriageRequests;
